<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row class="mt-5">
            <v-col cols="12" lg="8" offset-lg="2">
                <v-btn
                    color="error"
                    text
                    href="/admin/parent-stores"
                >Atrás</v-btn>
                <v-card class="mb-5">
                    <v-card-text>
                        <v-form @submit.prevent="formAdd" ref="refadd" lazy-validation>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <h4>Datos de la tienda</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <!-- name -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Nombre de la tienda"
                                        type="text"
                                        outlined
                                        dense
                                        v-model="data.name"
                                        :rules="[rules.required]"
                                        :error="errors['title'] ? true :false"
                                        :error-messages="errors['title'] ? errors['title'][0] : ''"
                                        @blur="generateSlug"
                                    ></v-text-field>
                                </v-col>
                                <!-- end name -->
                                <!-- slug -->
                                <v-col cols="12" md="6" class="px-2">
                                    <strong>Slug:</strong> <br>
                                    {{ tmpSlug }}<a>{{ data.slug }}</a>
                                </v-col>
                                <!-- end slug -->

                                <!-- button color -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-menu v-model="data.menu4" bottom offset-y :close-on-content-click="false" max-width="300px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="mb-7 text-capitalize"
                                                block
                                            >
                                                Color de fondo de los enlaces
                                                <v-sheet
                                                    elevation="1"
                                                    height="20px"
                                                    width="80px"
                                                    :color="data.btnColor"
                                                    class="rounded ml-auto"
                                                ></v-sheet>
                                            </v-btn>
                                        </template>
                                        <v-card max-width="300px">
                                            <v-color-picker
                                                dot-size="28"
                                                hide-mode-switch
                                                swatches-max-height="188"
                                                v-model="data.btnColor"
                                            ></v-color-picker>
                                            <div class="text-right pb-2 px-2">
                                                <v-btn small dark @click="data.menu4=false">Aceptar</v-btn>
                                            </div>
                                        </v-card>
                                    </v-menu>
                                </v-col>
                                <!-- end button color -->

                                <!-- text boton color -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-menu v-model="data.menu5" bottom offset-y :close-on-content-click="false" max-width="300px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="mb-7 text-capitalize"
                                                block
                                            >
                                                Color de texto de los enlaces
                                                <v-sheet
                                                    elevation="1"
                                                    height="20px"
                                                    width="80px"
                                                    :color="data.textbtnColor"
                                                    class="rounded ml-auto"
                                                ></v-sheet>
                                            </v-btn>
                                        </template>
                                        <v-card max-width="300px">
                                            <v-color-picker
                                                dot-size="28"
                                                hide-mode-switch
                                                swatches-max-height="188"
                                                v-model="data.textbtnColor"
                                            ></v-color-picker>
                                            <div class="text-right pb-2 px-2">
                                                <v-btn small dark @click="data.menu5=false">Aceptar</v-btn>
                                            </div>
                                        </v-card>
                                    </v-menu>
                                </v-col>
                                <!-- end text boton color -->

                                <!-- contenido color -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-menu v-model="data.menu6" bottom offset-y :close-on-content-click="false" max-width="300px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="mb-7 text-capitalize"
                                                block
                                            >
                                                Color del texto del contenido
                                                <v-sheet
                                                    elevation="1"
                                                    height="20px"
                                                    width="80px"
                                                    :color="data.contentColor"
                                                    class="rounded ml-auto"
                                                ></v-sheet>
                                            </v-btn>
                                        </template>
                                        <v-card max-width="300px">
                                            <v-color-picker
                                                dot-size="28"
                                                hide-mode-switch
                                                swatches-max-height="188"
                                                v-model="data.contentColor"
                                            ></v-color-picker>
                                            <div class="text-right pb-2 px-2">
                                                <v-btn small dark @click="data.menu6=false">Aceptar</v-btn>
                                            </div>
                                        </v-card>
                                    </v-menu>
                                </v-col>
                                <!-- end contenido color -->

                                <!-- banner color -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-menu v-model="data.menu8" bottom offset-y :close-on-content-click="false" max-width="300px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="mb-7 text-capitalize"
                                                block
                                            >
                                                Color de fondo del body
                                                <v-sheet
                                                    elevation="1"
                                                    height="20px"
                                                    width="80px"
                                                    :color="data.bodyColor"
                                                    class="rounded ml-auto"
                                                ></v-sheet>
                                            </v-btn>
                                        </template>
                                        <v-card max-width="300px">
                                            <v-color-picker
                                                dot-size="28"
                                                hide-mode-switch
                                                swatches-max-height="188"
                                                v-model="data.bodyColor"
                                            ></v-color-picker>
                                            <div class="text-right pb-2 px-2">
                                                <v-btn small dark @click="data.menu8=false">Aceptar</v-btn>
                                            </div>
                                        </v-card>
                                    </v-menu>
                                </v-col>
                                <!-- end banner color -->

                                <!-- if banner -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-switch
                                        v-model="data.ifBody"
                                        inset
                                        :label="`${(data.ifBody)?'Mostrar imagen en body':'Ocultar imagen en body'}`"
                                    ></v-switch>
                                </v-col>
                                <!-- end if banner -->

                                <!-- body -->
                                <v-col cols="12" md="12" class="px-2" v-if="data.ifBody">
                                    <v-file-input
                                        label="Body"
                                        accept="image/png"
                                        prepend-icon="mdi-image"
                                        outlined
                                        dense
                                        v-model="data.body"
                                    ></v-file-input>
                                </v-col>
                                <!-- end body -->

                                <!-- favicon -->
                                <v-col cols="12" md="12" class="px-2">
                                    <v-file-input
                                        label="Favicon"
                                        accept="image/png"
                                        prepend-icon="mdi-image"
                                        outlined
                                        dense
                                        v-model="data.favicon"
                                    ></v-file-input>
                                </v-col>
                                <!-- end favicon -->

                                <!-- status -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-switch
                                        v-model="data.state"
                                        inset
                                        :label="`Estado: ${(data.state)?'activo':'inactivo'}`"
                                    ></v-switch>
                                </v-col>
                                <!-- end status -->

                                <!-- edit -->
                                <v-col cols="12" class="px-2">
                                    contenido
                                    <vue-editor v-model="data.content" :editor-toolbar="customToolbar" />
                                </v-col>
                                <!-- end edit -->

                                <v-col cols="12" sm="12" class="text-center pt-10">
                                    <v-btn
                                        type="submit"
                                        dark
                                        color="primary"
                                        :loading="loading"
                                    >
                                        Guardar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
import Quill from "quill";
const FontAttributor = Quill.import('attributors/class/font');
FontAttributor.whitelist = ["serif","aftika", "marr-sans-cond", "sanomat", "monospace"];
Quill.register(FontAttributor, true);

export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Tiendas',
                    disabled: false,
                    href: '/admin/parent-stores',
                },
                {
                    text: 'Nuevo',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/shop/',
            // editor
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                [{ font: ["serif","aftika", "marr-sans-cond", "sanomat", "monospace"]}],
                ["bold", "italic", "underline"],
                [{ align: "" }, { align: "center" }, { align: "right"}, { align: "justify"}],
                [{ list: "ordered" }, { list: "bullet" }],
                // [{ color: [] }, { background: [] }],
                ['link'],
                ['image']
            ],
            // data
            data: {
                id: '',

                name: '',
                slug: '',

                btnColor: '',
                menu4: false,

                textbtnColor: '',
                menu5: false,

                contentColor: '',
                menu6: false,

                bodyColor: '',
                menu8: false,
                body: null,
                ifBody: false,

                favicon: null,

                content: ''
            },
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            errors: {},
        }
    },
    props: ['dataParentstore'],
    mounted() {
        const tmpData = JSON.parse(this.dataParentstore)
        console.log(tmpData);
        this.data.id = tmpData.id
        this.data.name = tmpData.title
        this.data.slug = tmpData.slug
        this.data.btnColor = tmpData.btn_color
        this.data.textbtnColor = tmpData.btn_txt_color
        this.data.contentColor = tmpData.body_txt_color
        this.data.bodyColor = tmpData.body_color
        // this.data.body = null
        this.data.ifBody = (tmpData.if_banner)?true:false
        this.data.state = (tmpData.state)?true:false
        this.data.content = tmpData.content
    },
    methods: {
        /**
         * register
         */
        async generateSlug(e) {
            var tmpSlug = (e.target.value).replace(/\s+/g, '-').toLowerCase()
            await axios.post('/admin/parent/verify-slug', {tmpslug: tmpSlug})
            .then((response) => {
                // console.log(response)
                this.data.slug = response.data
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async formAdd() {
            if (this.$refs.refadd.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('title', this.data.name)
                formData.append('slug', this.data.slug)
                formData.append('btn_color', this.data.btnColor)
                formData.append('btn_txt_color', this.data.textbtnColor)
                formData.append('body_color', this.data.bodyColor)
                formData.append('body_txt_color', this.data.contentColor)
                formData.append('if_banner', this.data.ifBody?1:0)
                formData.append('bbanner', this.data.body)
                formData.append('favicon', this.data.favicon)
                formData.append('content', this.data.content)
                formData.append('state', this.data.state?1:0)
                formData.append('type', 'page')
                formData.append('_method', 'PUT')

                await axios.post(`/admin/edit-parent-store/${this.data.id}`, formData)
                .then((response) => {
                    console.log(response);
                    if (response.data == 'ok') {
                        this.$alert('', 'Registro con éxito.', 'success', {confirmButtonText: 'Continuar'})
                        this.$refs.refadd.resetValidation()
                    }
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error);
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                        this.$alert('Todos los campos con requeridos.');
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        }
    },
}
</script>
